import { createContext } from 'react';

const chartState = { chartState: undefined, setChartState: undefined }

export const ChartContext = createContext(chartState);